// Pop-up windows with jquery (http://www.djsipe.com/2008/07/04/doing-pop-ups-the-right-way-with-jquery/)
// Create a namespace for our utilities
window["UTIL"] = window.UTIL || {};
window.UTIL.popup = window.UTIL.popup || {};

window["clearAllNextSelect"] = function (cur_select) {
    return cur_select.nextAll("select")
        .each(function () {
            $(this).html('<option value=""></option>').hide();
        })
        .first();
}

window["modShortcut"] = function (button, cat_arr, show_child_select) {
    const num_selects = show_child_select ? cat_arr.length + 1 : cat_arr.length;

    for (var i = 0; i < num_selects; i++) {
        // Look for the form within the closest modActions container
        const sel = button.closest('.modActions').find("select[name^='todo\[" + i + "\]']"),
            cat_slice_end = i < cat_arr.length ? i : cat_arr.length,
            selected = i < cat_arr.length ? cat_arr[i] : undefined;

        modPopulateSelect(sel, cat_arr.slice(0, cat_slice_end), selected);
        sel.show();

        if (i === 0) clearAllNextSelect(sel);
    }
}

// Focus on first report's action select box
window["focusNextRep"] = function (cur_rep) {
    let next_rep;
    if (cur_rep === undefined) {
        next_rep = $("div.userReport:visible").first();
    } else {
        next_rep = cur_rep.nextAll(".userReport:visible").first();
    }

    if (next_rep.length > 0) {
        const $select = next_rep.find(".mod_actions_sel").first();
        if ($select.length > 0) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
                $select.focus();
            }, 100);
        }
    }
};

window["modPopulateSelect"] = function (select_elem, levels, selectedIdx) {
    let cur_values = {};
    $.each(levels, function (i, v) {
        cur_values["levels[" + i + "]"] = v;
    });
    // Get new option set
    $.getJSON("/async/mod/report_queue.php", cur_values, function (j) {
        if (j !== null && !$.isEmptyObject(j)) {
            var options = '';
            var i = 0;
            $.each(j, function (val, name) {
                options += '<option value="' + val + '">' + i + ': ' + name + '</option>';
                i++;
            });
            select_elem.html(options).show().focus();
            if (selectedIdx !== undefined) {
                select_elem.val(selectedIdx);
                select_elem.attr("size", 1);
            } else {
                select_elem.attr("size", i);
                select_elem.val('');
            }
        } else {
            select_elem.html('<option value=""></option>').hide();
        }
    });
}

//
// Open popup window
//
// Opens a popup window using as little as a URL. An optional params object can
// be passed.
//
// @param {String} href
// @param {Object} params
// @return {WindowObjectReference}
//
UTIL.popup.open = function (href, params) {
    // Defaults (don't leave it to the browser)
    var defaultParams = {
        "width": "600",   // Window width
        "height": "420",   // Window height
        "top": "0",     // Y offset (in pixels) from top of screen
        "left": "0",     // X offset (in pixels) from left side of screen
        "directories": "no",    // Show directories/Links bar?
        "location": "no",    // Show location/address bar?
        "resizeable": "yes",   // Make the window resizable?
        "menubar": "no",    // Show the menu bar?
        "toolbar": "no",    // Show the tool (Back button etc.) bar?
        "scrollbars": "yes",   // Show scrollbars?
        "status": "no"     // Show the status bar?
    };

    var windowName = params["windowName"] || "new_window";

    var i, useParams = "";

    // Override defaults with custom values while we construct the params string
    for (i in defaultParams) {
        useParams += (useParams === "") ? "" : ",";
        useParams += i + "=";
        useParams += params[i] || defaultParams[i];
    }

    return window.open(href, windowName, useParams);
};


$(function () {
    var cats_novio = [3, 14];
    var cats_scams = [2, 27, 47];
    var cats_sex = [2, 27, 48];


    // Keyboard shortcuts for moderation actions (0-5 keys)
    $(document).on('keydown', function(e) {
        // Only handle number keys 0-5 when not in an input field
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') {
            return;
        }

        // Don't interfere with browser shortcuts (Cmd/Ctrl/Alt+key combinations)
        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) {
            return;
        }

        const key = e.key;
        if (key >= '0' && key <= '5') {
            e.preventDefault();
            
            // Find the currently visible report's action select
            const $visibleReport = $("div.userReport:visible").first();
            if ($visibleReport.length === 0) return;
            
            const $actionSelect = $visibleReport.find(".mod_actions_sel:visible").first();
            if ($actionSelect.length === 0) return;
            
            // Focus the select if not already focused
            if (!$actionSelect.is(':focus')) {
                $actionSelect.focus();
            }
            
            // Select the option by index
            const optionIndex = parseInt(key);
            const $options = $actionSelect.find('option');
            if (optionIndex < $options.length) {
                $actionSelect.val($options.eq(optionIndex).val());
                $actionSelect.trigger('change');
                
                // After selecting, check if this was the last select and focus log message
                setTimeout(function() {
                    const $nextVisibleSelect = $visibleReport.find(".mod_actions_sel:visible");
                    const $lastVisibleSelect = $nextVisibleSelect.last();
                    
                    // If the current select is the last visible one, focus the log message
                    if ($actionSelect.is($lastVisibleSelect)) {
                        const $logMsg = $visibleReport.find("textarea[name='log_msg'], .logMsgTA").first();
                        if ($logMsg.length > 0) {
                            $logMsg.focus();
                        }
                    }
                }, 150);
            }
        }
    });

    // Report page shortcuts
    $(".modact_novio").click(function () {
        modShortcut($(this), cats_novio);
    });

    $(".modact_scams").click(function () {
        modShortcut($(this), cats_scams, true);
    });
    $(".modact_sex").click(function () {
        modShortcut($(this), cats_sex, true);
    });


    $(".archive").click(function () {
        $(this).parents("form").find("input[name='todo']").val("archive");
    });
    $(".del_reports").click(function () {
        $(this).parents("form").find("input[name='todo']").val("del_reports");
    });
    $(".delete").click(function () {
        $(this).parents("form").find("input[name='todo']").val("delete");
    });
    $(".delScam").click(function () {
        $(this).parents("form").find("input[name='todo']").val("delete");
        $(this).parents("form").find("textarea[name='log_msg']").val("fast:scam");
    });
    $(".logMsgSubmit").click(function () {
        $(this).parents("form").find("input[name='todo']").val("log_msg");
    });
    $(".del_photo").click(function (e) {
        $(this).parents("form").find("input[name='todo']").val("delete_photo");
        $(this).parents("form").find("input[name='pid']").val($(this).attr('pid'));
        $(this).parents("form").submit();
        e.preventDefault();
    });
    $(".appr_photo").click(function (e) {
        $(this).parents("form").find("input[name='todo']").val("approve_photo");
        $(this).parents("form").find("input[name='pid']").val($(this).attr('pid'));
        $(this).parents("form").submit();
        e.preventDefault();
    });
    $(".reset_changes").click(function (e) {
        if (confirm($(this).attr('conf'))) {
            $(this).parents("form").find("input[name='todo']").val($(this).attr('name'));
            $(this).parents("form").submit();
        }
        e.preventDefault();
    });
    $(".show_del_options").click(function (e) {
        $(".modActDel").toggle();
        e.preventDefault();
    });
    $(".show_reset_options").click(function (e) {
        $(".modActReset").toggle();
        e.preventDefault();
    });

//  // "Clear all reports by this reporter"
//  $(".del_reports_by_user").click(function(e) {
//    $(this).parents("form").find("input[name='todo']'").val("del_reports_by_user");
//    $(this).parents("form").find("input[name='rep_uid']'").val($(this).attr('rep_uid'));
//    $(this).parents("form").submit();
//    e.preventDefault();
//  });
//
    // SUBMIT moderation action for a given report.
    // On success, hide the item. Otherwise, show an alert.
    $(".asyncReportForm").submit(function (e) {
        e.preventDefault();
        var f = $(this);
        var ta = f.find("[name=log_msg]");
        if (ta.val().replace(/(\n|\r|\s)+$/, '') == "Comments...") {
            ta.val('');
        }
        ta.addClass("ajx_load");
        var repForm = $(this);
        $.post("/mod/moderate.php?async=1", repForm.serialize(),
            function (data) {
                switch (data) {
                    case '0':
                        // Success: hide user reports
                        // Check if we're in a modal iframe
                        if (window.top !== window.self) {
                            // We're in an iframe/modal, reload the parent page
                            window.top.location.reload(true);
                        } else {
                            // Regular page behavior - hide the report 
                            f.parents(".userReport").hide();
                            focusNextRep(repForm.parents("div.userReport"));
                        }
                        break;
                    case '1':
                        // Reload page
                        if (window.top !== window.self) {
                            window.top.location.reload(true);
                        } else {
                            window.location.reload(true);
                        }
                        break;
                    default:
                        alert(data);
                }
                ta.removeClass("ajx_load");
            });
    });

    // Clear a flagged profile
    $(".clearFlagged").click(function (e) {
        e.preventDefault();
        var ele = $(this);
        $.get($(this).parents("form").find("input[name='clear_url']").val(),
            function () {
                ele.parents("div.acctFlag").hide();
            }
        );
    });

    // Show jQuery-dependent form elements once DOM is loaded
    $(".modActions").show();
    $(".flaggedForm").show();

    // Jump to url based on the value of a select element
    $(".selNav").removeAttr("disabled").change(function () {
        window.location = $(this).val();
    });


    // Load pop-up windows
    $(function () { // Run this code when document is done loading
        $("a.popup").each(function (i) {
            $(this).click(function (event) {
                event.preventDefault();
                var params = $(this).data("popup") || {};
                if ($(this).attr("target")) {
                    params.windowName = $(this).attr("target");
                }
                var windowObject = UTIL.popup.open(this.href, params);
                $(this).data("windowObject", windowObject);
            });
        });
        $(".del_apprv_links").show();
    });

    // Load moderation warning templates (mod/warn.php)
    $('.mwt_link').click(function (e) {
        $('#subject').val($(this).attr('title'));
        $('#msg').val($('#' + $(this).attr('href')).html() + ($('#mwt_base').html()));
        e.preventDefault();
    });
    $('#modWarnTplLinks').show();


    // Dynamically populate select elements
    $("select.mod_action").change(function () {
        $(this).attr("size", 1);

        // Clear all sub-selects & save next select ref
        let next_select = clearAllNextSelect($(this));

        // Display final warning checkbox if Warn is selected
        if ($(this).attr('name') == "todo[0]") {
            if ($(this).val() == 'warn') {
                $(this).nextAll('.fwarning').first().show();
            } else {
                $(this).nextAll('.fwarning').first().hide();
            }
        }

        // Get selected values for each select element
        let levels = [];
        $(this).parent().find("select.mod_action").each(function (i) {
            levels.push($(this).val());
        });
        modPopulateSelect(next_select, levels);
        
        // After populating, check if this is the last select and auto-focus log message
        const $form = $(this).closest('form');
        const $currentSelect = $(this);
        
        setTimeout(function() {
            // Check if there are no more visible selects after this one
            const $allSelects = $form.find(".mod_actions_sel:visible");
            const isLastSelect = $currentSelect.is($allSelects.last());
            
            if (isLastSelect && $currentSelect.val()) {
                // Focus the log message textarea
                const $logMsg = $form.find("textarea[name='log_msg'], .logMsgTA").first();
                if ($logMsg.length > 0) {
                    $logMsg.focus();
                }
            }
        }, 200);
    });

    $(".logMsgTA").focus(function () {
        if ($(this).val().replace(/(\n|\r|\s)+$/, '') == "Comments...") {
            $(this).height("100px")
                .attr("color", "#000").val('');
        }
    });
    
    // Add Ctrl+Enter to submit the moderation form
    $(document).on('keydown', 'textarea[name="log_msg"], .logMsgTA', function(e) {
        if (e.ctrlKey && e.key === 'Enter') {
            e.preventDefault();
            $(this).closest('form').submit();
        }
    });

    // Alpine.js modal for moderating users
    // Create the modal container if it doesn't exist
    if (!document.getElementById('moderateUserModalContainer')) {
        const modalHtml = `
            <div id="moderateUserModalContainer"
                 x-data="moderateUserModal()"
                 x-show="open"
                 x-cloak
                 @keydown.escape.window="close()"
                 @open-moderate-modal.window="openModal($event.detail.userId)"
                 class="fixed inset-0 z-[9999] overflow-hidden"
                 role="dialog"
                 aria-modal="true"
                 aria-labelledby="moderate-user-title">

                <!-- Backdrop -->
                <div x-show="open"
                     x-transition:enter="transition ease-out duration-200"
                     x-transition:enter-start="opacity-0"
                     x-transition:enter-end="opacity-100"
                     x-transition:leave="transition ease-in duration-150"
                     x-transition:leave-start="opacity-100"
                     x-transition:leave-end="opacity-0"
                     @click="close()"
                     class="fixed inset-0 bg-black/50"></div>

                <!-- Modal panel - full screen on mobile, centered dialog on sm+ -->
                <div class="fixed inset-0 flex items-end sm:items-start justify-center sm:p-6 lg:p-8 overflow-y-auto">
                    <div x-show="open"
                         x-transition:enter="transition ease-out duration-200"
                         x-transition:enter-start="opacity-0 max-sm:translate-y-full sm:scale-95 sm:translate-y-4"
                         x-transition:enter-end="opacity-100 max-sm:translate-y-0 sm:scale-100 sm:translate-y-0"
                         x-transition:leave="transition ease-in duration-150"
                         x-transition:leave-start="opacity-100 max-sm:translate-y-0 sm:scale-100 sm:translate-y-0"
                         x-transition:leave-end="opacity-0 max-sm:translate-y-full sm:scale-95 sm:translate-y-4"
                         @click.stop
                         class="bg-white w-full max-sm:h-full max-sm:max-h-full sm:rounded-2xl shadow-2xl sm:max-w-5xl sm:my-4 flex flex-col sm:max-h-[calc(100vh-4rem)] overflow-hidden">

                        <!-- Header -->
                        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0" style="padding-top: max(0.75rem, env(safe-area-inset-top));">
                            <h2 id="moderate-user-title" class="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                                </svg>
                                Moderate User
                            </h2>
                            <button @click="close()"
                                    type="button"
                                    class="p-1.5 rounded-full hover:bg-gray-100 transition-colors"
                                    aria-label="Close">
                                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                </svg>
                            </button>
                        </div>

                        <!-- Content area -->
                        <div class="flex-1 overflow-y-auto p-4 lg:p-6 bg-gray-50 max-sm:pb-[env(safe-area-inset-bottom)]">
                            <!-- Loading state -->
                            <template x-if="loading">
                                <div class="flex items-center justify-center py-12">
                                    <svg class="animate-spin h-8 w-8 text-sky-500" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>
                            </template>

                            <!-- Error state -->
                            <template x-if="error && !loading">
                                <div class="text-center py-12">
                                    <svg class="w-12 h-12 mx-auto text-red-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                                    </svg>
                                    <p class="text-gray-600" x-text="error"></p>
                                    <button @click="retry()" class="mt-4 px-4 py-2 bg-sky-500 text-white rounded-lg hover:bg-sky-600 transition-colors">
                                        Retry
                                    </button>
                                </div>
                            </template>

                            <!-- Content (loaded via AJAX) -->
                            <template x-if="!loading && !error && content">
                                <div x-ref="content"
                                     x-html="content"
                                     x-effect="if (content && $refs.content) { $nextTick(() => { window.LucideIcons?.initialize($refs.content); $refs.content.querySelectorAll('[data-b64email]').forEach(el => { el.textContent = atob(el.dataset.b64email); }); }); }">
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }

    // Alpine.js component for the moderate user modal
    window.moderateUserModal = function() {
        return {
            open: false,
            loading: false,
            error: null,
            content: '',
            userId: null,

            async openModal(userId) {
                this.userId = userId;
                this.open = true;
                this.loading = true;
                this.error = null;
                this.content = '';

                // Lock body scroll
                window.scrollLock?.lock();

                try {
                    const response = await fetch(`/mod/user.php?todo=ajax&user_id=${userId}`);
                    if (!response.ok) {
                        throw new Error('Failed to load user data');
                    }
                    this.content = await response.text();
                } catch (err) {
                    this.error = err.message || 'An error occurred';
                } finally {
                    this.loading = false;
                }
            },

            retry() {
                if (this.userId) {
                    this.openModal(this.userId);
                }
            },

            close() {
                this.open = false;
                this.content = '';
                this.error = null;
                this.userId = null;

                // Unlock body scroll
                window.scrollLock?.unlock();
            }
        };
    };

    // Keep legacy jQuery UI dialogs for messages and photos
    $("body").append('<div id="modMsgsDialog" title="Messages"></div>');
    $("#modMsgsDialog").dialog({
        autoOpen: false,
        width: 630,
        height: 700,
    });
    $("body").append('<div id="modPhotoDialog" title="Moderate Photo"></div>');
    $("#modPhotoDialog").dialog({
        autoOpen: false,
        width: 300,
        height: 200,
    });

    // Bind to mod link - dispatch Alpine.js event
    $(document).on('click', '.profModLink', function (e) {
        e.preventDefault();
        var userId = $(this).attr('user-id');

        // Dispatch custom event to open the Alpine.js modal
        window.dispatchEvent(new CustomEvent('open-moderate-modal', {
            detail: { userId: userId }
        }));
    });

    // Bind to sent messages link
    $(".modMsgsLink").click(function (e) {
        $("#modMsgsDialog").html('<iframe id="modIframeMsgs" width="100%" ' +
            'height="100%" marginWidth="0" marginHeight="0" frameBorder="0" ' +
            'scrolling="auto" />')
            .dialog("open");
        $("#modIframeMsgs").attr("src", $(this).attr('href'));
        e.preventDefault();
    });

    // Bind to user photo moderation link
    $('.mod_photo').click(function (e) {
        $("#modPhotoDialog").html('<iframe id="modIframePhoto" width="100%" ' +
            'height="100%" marginWidth="0" marginHeight="0" frameBorder="0" ' +
            'scrolling="auto" />')
            .dialog("open");
        $("#modIframePhoto").attr("src", $(this).attr('href'));
        e.preventDefault();
    });

    /*
    // Photo moderation dialog
    $(".mod_photo").click(function (e) {
        let dialog_id = $(this).data("targetid");
        const photo_dialog = $("#" + dialog_id);
        photo_dialog.dialog({
            autoOpen: false,
            width: 300,
            height: 200,
            title: "Moderate Photo",
            buttons: {
                "Submit": function () {
                    $.post("/mod/moderate.php?async=1",
                        $("#" + dialog_id + "_form").serialize(),
                        function (data) {
                            if (data != '0') {
                                alert("Error: " + data);
                            } else {
                                window.location.reload(true);
                            }
                        });
                    $(this).dialog("close");
                },
                "Cancel": function () {
                    $(this).dialog("close");
                }
            },
        });
        photo_dialog.dialog("open");
        e.preventDefault();
    });
     */
});
